var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.show)?[_c('b-button',{attrs:{"variant":"link"},on:{"click":_vm.click}},[_vm._v(_vm._s(_vm.type.label))])]:_vm._e(),_vm._v(" "),(!_vm.show)?[_vm._v(_vm._s(_vm.type.label))]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }